export enum BenefitsType {
    FIXED = 'FIXED',
    HOURLY = 'HOURLY',
    DAILY = 'DAILY',
    PERCENTAGE = 'PERCENTAGE'
}

export enum PlanBenefitsType {
    MANDATORY = 'MANDATORY',
    OPTIONAL = 'OPTIONAL'
}
export enum SectionOFCover {
    A = 'A',
    B = 'B',
    C = 'C',
    D = 'D',
    E = 'E',
    F = 'F',
    G = 'G',
    H = 'H',
    I = 'I'
}
